var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.isReadOnly ? "查看终端" : "编辑终端",
        visible: _vm.visible,
        width: "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "card-container" },
        [
          _c(
            "span",
            {
              staticClass: "card-header-title",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_vm._v("基本信息")]
          ),
          _c(
            "el-descriptions",
            { attrs: { column: 3, border: "", size: "small" } },
            [
              _c("el-descriptions-item", { attrs: { label: "终端SN" } }, [
                _vm._v(_vm._s(_vm.formData.posSn)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "终端类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "edit-select",
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        disabled: _vm.isReadOnly,
                      },
                      model: {
                        value: _vm.formData.amountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "amountType", $$v)
                        },
                        expression: "formData.amountType",
                      },
                    },
                    _vm._l(_vm.amountTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.desc, value: item.code },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "是否激活" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "edit-select",
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        disabled: _vm.isReadOnly,
                      },
                      model: {
                        value: _vm.formData.hasActivate,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "hasActivate", $$v)
                        },
                        expression: "formData.hasActivate",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "是", value: 1 } }),
                      _c("el-option", { attrs: { label: "否", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "分公司" } }, [
                _vm._v(_vm._s(_vm.getGroupName(_vm.formData.groupId))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "业务员" } }, [
                _vm._v(_vm._s(_vm.getSalesName(_vm.formData.salesId))),
              ]),
              _c("el-descriptions-item", { attrs: { label: "平台" } }, [
                _vm._v(_vm._s(_vm.formData.platfromName)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "入库时间" } }, [
                _vm._v(_vm._s(_vm.formData.storeTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "下拨时间" } }, [
                _vm._v(_vm._s(_vm.formData.allocateTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "回拨时间" } }, [
                _vm._v(_vm._s(_vm.formData.callbackTime)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container" },
        [
          _c(
            "span",
            {
              staticClass: "card-header-title",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_vm._v("操作历史")]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.formData.transferRecordList,
                stripe: "",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "transferType",
                  label: "操作类型",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.transferType === 0
                          ? _c("span", { staticClass: "tag-allocate" }, [
                              _vm._v("下拨"),
                            ])
                          : scope.row.transferType === 1
                          ? _c("span", { staticClass: "tag-callback" }, [
                              _vm._v("回拨"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "oldGroupName",
                  label: "分公司",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "groupName",
                  label: "新分公司",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "oldSalesName",
                  label: "业务员",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "salesName",
                  label: "新业务员",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "allocateTime",
                  label: "下拨时间",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "callbackTime",
                  label: "回拨时间",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.submitLoading },
              on: { click: _vm.handleClose },
            },
            [_vm._v("取消")]
          ),
          !_vm.isReadOnly
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确认")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }